export function parseLessonIds(lessonIds) {
  return String(lessonIds ?? '')
    .split(',')
    .map(lessonId => Number(lessonId.trim()))
    .filter(lessonId => Number.isFinite(lessonId) && lessonId > 0);
}

export function syncAvailableReserveLessonOptions(
  previousOptions,
  availableLessonData,
  availableLessonIds,
  storeId,
  membershipId
) {
  if (availableLessonData === undefined) return previousOptions;

  const selectedLessonIds = parseLessonIds(availableLessonIds);

  // 회원권 전환 중 SelectBox가 선택 수업을 재구성하기 전에 기존 옵션을 지우지 않도록 보존 //
  if (selectedLessonIds.length !== availableLessonData.length
      || availableLessonData.some(data => !selectedLessonIds.includes(Number(data.id)))) {
    return previousOptions;
  }

  const updated = previousOptions.filter(option =>
    availableLessonData.some(data => Number(data.id) === Number(option.lessonId))
  );

  for (const lesson of availableLessonData) {
    if (!updated.some(option => Number(option.lessonId) === Number(lesson.id))) {
      updated.push({
        storeId,
        membershipId,
        lessonId: lesson.id,
        lessonName: lesson.name,
        color: lesson.color,
        dayMax: -1,
        weekMax: -1,
        weekCountMax: -1
      });
    }
  }

  return updated;
}

export function syncPartnerGymAvailableReserveLessonOptions(
  previousOptions,
  availablePartnerGymLessonData,
  lessonData,
  storeId,
  membershipId
) {
  if (availablePartnerGymLessonData === undefined) return previousOptions;

  const hasSameLogicalKey = (option, selectedLesson) =>
    Number(option.followStoreId) === Number(selectedLesson.followStoreId)
    && Number(option.lessonId) === Number(selectedLesson.followLessonId);

  const updated = previousOptions.filter(option =>
    availablePartnerGymLessonData.some(selectedLesson => hasSameLogicalKey(option, selectedLesson))
  );

  for (const selectedLesson of availablePartnerGymLessonData) {
    if (!updated.some(option => hasSameLogicalKey(option, selectedLesson))) {
      const lessonId = Number(selectedLesson.followLessonId);
      const lesson = lessonData.find(data => Number(data.id) === lessonId);

      updated.push({
        storeId,
        membershipId,
        followStoreId: selectedLesson.followStoreId,
        lessonId,
        lessonName: lesson?.name || '',
        color: lesson?.color || 0,
        dayMax: -1,
        weekMax: -1,
        weekCountMax: -1
      });
    }
  }

  return updated;
}
